import React, { useEffect } from "react";
import {
  SpmIntegrationDraft,
  SpmIntegrationInfo,
} from "../../../types/spmIntegrationInfo";
import { Form, Input, Modal } from "antd";

export interface SpmIntegrationFormProps {
  open: boolean;
  record?: SpmIntegrationInfo;
  onSave: (record: SpmIntegrationDraft) => void;
  onCancel: () => void;
}

export const SpmIntegrationForm = (props: SpmIntegrationFormProps) => {
  const [form] = Form.useForm<SpmIntegrationDraft>();
  const { record, open } = props;

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(record ?? {});
  }, [record, open, form]);

  return (
    <Modal
      open={props.open}
      title={record ? "Edit SPM Integration" : "Add SPM Integration"}
      okText={record ? "Save" : "Add"}
      cancelText="Cancel"
      onCancel={props.onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            props.onSave(values);
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
      }}
    >
      <Form form={form} layout="vertical" name="spm_integration_form">
        <Form.Item
          name="url"
          label="URL"
          rules={[{ required: true, message: "Please input the URL!" }]}
        >
          <Input aria-label="URL" />
        </Form.Item>
        <Form.Item
          name="version"
          label="Version"
          rules={[{ required: true, message: "Please input the version!" }]}
        >
          <Input aria-label="Version" />
        </Form.Item>
        <Form.Item
          name="product"
          label="Product"
          rules={[{ required: true, message: "Please input the product!" }]}
        >
          <Input aria-label="Product" />
        </Form.Item>
        <Form.Item name="replacesPod" label="Replaces Pod">
          <Input aria-label="Replaces Pod" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
